var app = angular.module('leonardo');

var ToolTipDirective = function($timeout, $window, ConfigThemeService) {
  return {
    restrict: 'C',
    scope: {
      timeout: '='
    },
    link: function (scope, element, attrs) {

      scope.onElement = false;

      var bottom = element.hasClass('bottom');
      var top = element.hasClass('top');
      var blue = element.hasClass('blue');

      scope.setColor = function () {
        if (blue) {
          element.css('background-color', ConfigThemeService.getColor('secondaryColor', 0.8));
        }
        else {
          element.css('background-color', ConfigThemeService.getColor('warningColor', 0.8));
        }
      };

      element.parent().on('mouseover', function(event) {
        if (scope.onElement) {
          return;
        }
        element.stop();
        var height = element.outerHeight();
        var parent = element.parent().outerWidth();
        var parent_height = element.parent().outerHeight();
        var right = angular.element($window).width() - (element.parent().offset().left + element.parent().outerWidth());
        element.fadeIn('slow');
        if (right < element.outerWidth()){
          element.addClass('right');
          if (blue) {
            element.css({minWidth: element.find('span').width(), right: parent, top: -(height/2)+(parent_height/2)});
          }
          else {
            element.css({right: (parent + 20), top: -(height/2)+(parent_height/2)});
          }
          if (bottom) {
            element.css({minWidth: element.find('span').width(), right: 0, top: (parent_height + 5)});
          }
          if (top) {
            element.css({minWidth: element.find('span').width(), right: 0, top: -(height + 5)});
          }
        }
        else {
          if (blue) {
            element.css({minWidth: element.find('span').width(), left: parent, top: -(height/2)+(parent_height/2)});
          }
          else {
            element.css({left: (parent + 20), top: -(height/2)+(parent_height/2)});
          }
          if (bottom) {
            element.css({minWidth: element.find('span').width(), left: -(element.outerWidth()/2)+(parent/2), top: (parent_height + 10)});
          }
          if (top) {
            element.css({minWidth: element.find('span').width(), left: -(element.outerWidth()/2)+(parent/2), top: -(height + 10)});
          }
        }
        if (scope.timeout !== undefined) {
          $timeout(function(){
            element.fadeOut('fast');
          }, scope.timeout);
        }
      });

      scope.setColor();

      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });

      element.parent().on('mouseleave', function(event) {
        scope.onElement = false;
        element.stop();
        element.fadeOut('fast');
      });
      element.on('mouseover', function(event) {
        scope.onElement = true;
        element.stop();
        element.fadeOut('fast');
      });
    }
  };
};

app.directive('tooltip', ['$timeout', '$window', 'ConfigThemeService', ToolTipDirective]);
